<template>
    <transition name="modal">
        <div v-show="isVisible" class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modal-header">
                        <slot name="header">
                          Default Title
                        </slot>
                      <a href="#" class="close" @click.prevent="isVisible = false" aria-label="Close">
                        <img src="/img/close-neg.svg" alt="Close">  
                      </a>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                          Default Body
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                          Default Footer
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
          id: { type: String, required: true },
          visible: { type: Boolean, required: false, default: false },
        },

        data() {
            return {
              isVisible: false
            }
        },

        created() {
            EventDispatcher.listen('showDialog' + this.id, (doShowDialog) => {
                this.isVisible = doShowDialog;
            });
        }
    }
</script>

<style lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;

      .modal-wrapper {
          display: table-cell;
          vertical-align: middle;

        .modal-container {
            width: 400px;
            max-width: 80%;
            margin: 0px auto;
            padding: 10px;
            background-color: #fff;
            border-radius: 2px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
            transition: all .3s ease;
            font-family: Helvetica, Arial, sans-serif;

          .modal-header {
            padding: .15rem;
            border-bottom: none;

            h5 {
              font-family: cadiz;
              font-size: 1.2rem;
            }
            
            .close { 
              cursor: pointer;
              opacity:0.7;
              padding:0.75rem;

              &:hover {
                opacity:1;
              }
            }
          }

          .modal-body {
              font-family: cadiz;
              padding: 2rem .15rem;
          }

          .modal-footer {
              font-family: cadiz;
              justify-content: flex-start;
              padding: 1rem 0.25rem 0.25rem 0.25rem;
              border-top: none;

              button {
                font-size: 0.9rem;
                padding: 0.25rem 0.75rem;

                img {
                  height: 24px;
                }
              }
          }
        }
      }
    }

   
    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    */
    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container, .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
 
</style>
